enum BatchStatusEnum {
  STATUS_NEW = 1,
  STATUS_PENDING = 2,
  STATUS_COMPLETED = 3,
  STATUS_ERROR = 100,
}

const BatchStatusNames: Record<BatchStatusEnum, string> = {
  [BatchStatusEnum.STATUS_NEW]: 'new',
  [BatchStatusEnum.STATUS_PENDING]: 'pending',
  [BatchStatusEnum.STATUS_COMPLETED]: 'completed',
  [BatchStatusEnum.STATUS_ERROR]: 'error',
};

const BATCH_EXAMPLE_LIST: string[][] = [
  ['BTC', '3HQBsRNJcnzk4kcGxMabFMqD6Ud23T5eUd'],
  ['ETH', '0x4de23f3f0fb3318287378adbde030cf61714b2f3'],
  ['BSC', '...'],
  ['TRX', '...'],
  ['ARB', '...'],
  ['AVAX', '...'],
  ['DOT', '...'],
  ['BCH', '...'],
  ['XRP', '...'],
  ['LTC', '...'],
  ['TetherOMNI', '...'],
  ['MATIC', '...'],
  ['SOL', '...'],
  ['BSV', '...'],
  ['ETC', '...'],
  ['ALGO', '...'],
  ['DOGE', '...'],
  ['ADA', '...'],
  ['ZEC', '...'],
  ['XLM', '...'],
  ['TON', '...'],
  ['NEAR', '...'],
  ['XTZ', '...'],
];

export { BatchStatusEnum, BatchStatusNames, BATCH_EXAMPLE_LIST };
